import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl, intlShape} from 'react-intl';
import ResourceAccordion from "components/common/ResourceAccordion";
import ResourceFormProxy from "classes/ResourceFormProxy";

const IndexedSubSectionWrapper = (props) => {
    // Set it to the 'header' prop by default, then check if we have
    // any options that override it such as pulling from another field for
    // the header value (like showing a question as the title) or
    // passing in any props like {index} into the header
    let headerKeyText = props.header;

    if (props.headerKey && (headerKeyText === null || typeof(headerKeyText) === 'undefined')) {
        headerKeyText = props.intl.formatMessage({id: props.headerKey}, {index: props.index + 1});
    }

    return (
        <ResourceAccordion {...props}
                           header={headerKeyText}>
            {props.children}
        </ResourceAccordion>
    );
};

IndexedSubSectionWrapper.propTypes = {
    intl: intlShape,
    index: PropTypes.number.isRequired,
    deletable: PropTypes.bool,
    formProxy: PropTypes.instanceOf(ResourceFormProxy),
    toggleOpen: PropTypes.func,
    active: PropTypes.bool
};

IndexedSubSectionWrapper.defaultProps = {
    deletable: false
};

export default injectIntl(IndexedSubSectionWrapper);



// WEBPACK FOOTER //
// ./public/hoc/IndexedSubSectionWrapper.js